module.exports = __webpack_public_path__ + "media/images/twilio-logo-6125ca0d7a29ca82b2801c207c874dce.svg";